<template>
<mdb-container fluid>    
     <mdb-row class="justify-content-md-center header-row">
      <mdb-col lg="10" class="col-md-12 col-sm-10">
        <mdb-row>
            <div class="col-md-6 col-sm-7 ">
              <img class="logo-image align-left" width="170" :src="LOCAL_HOST+'/client-logo/wpo-logo.jpg'" >
            </div>
            
        </mdb-row>
      </mdb-col>
      
    </mdb-row>
  </mdb-container>
</template>

<script>
import {LOCAL_HOST} from '@/constants/general_constants';
import {mdbContainer, mdbRow, mdbCol} from 'mdbvue';
export default {
    name: 'Header',
    data() {
      return {
        LOCAL_HOST:this.$store.state.LOCAL_HOST            
      };        
    },
    components: {
      mdbContainer,
      mdbRow,
      mdbCol
    }
}; 
</script>
<style scoped>
.align-right{
  float: right;
}
.align-left{
  float: left;
}
.logo-image{
  padding: 27px 0 34px 0;
}
.header-row{
  background-image: linear-gradient(#ffffff 75%, #37474f29 );
}
</style>
